import API_public from "./API_public"
import { currentSecondsSinceEpoch } from "./time_helpers"
import * as Sentry from "@sentry/react";

const postScans = async (qr_data, device_name) => {
  try {
      const response = await API_public.post(`/scans`, { qr_data, device_name })
      return response.data
  } catch (e) {
      Sentry.withScope(scope => {
          scope.setExtra("handled", true)
          Sentry.captureException(e)
      })
      console.log(e)
      return {status: 'scan_invalid'};
  }
}

const parseResponseToScan = (result, qr_data, device_name) => {
  const scan = result.scan || {qr_data}
  scan.status = result.status
  scan.prev_scans = result.prev_scans || []
  scan.created_at = scan.created_at || currentSecondsSinceEpoch()
  scan.device_name = scan.device_name || device_name
  return scan
}

const validateTicket = async (qr_data, device_name) => {
  const result = await postScans(qr_data, device_name)
  return parseResponseToScan(result, qr_data, device_name)
}

export default validateTicket
